import React, { useEffect, useState } from 'react';
// Page Components

import CurrentBalance from 'components/CurrentBalance/CurrentBalance';
import Tabs from 'components/Tabs/Tabs';
import AccountDetails from 'components/AccountDetails/AccountDetails';
import TransactionHistory from './components/TransactionHistory/TransactionHistory';
import { ITEMS_PER_PAGE } from './components/TransactionHistory/TransactionHistory';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';

// Page styles
import styles from './TransactionHistoryPageData.module.scss';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const TransactionHistoryPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  console.log('TransactionHistoryLog', props);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid =
        LayoutModel?.Profiles.length > 0
          ? LayoutModel?.Profiles[0].DebtReference
          : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(
        userid,
        isLoggedIn,
        lang,
        reg,
        env,
        LayoutModel?.IsLoggedInUserSecured,
        LayoutModel?.SecuredCaseStatus,
      );
      getGTMVariablesPageView(
        window.document.title,
        window.location.href,
        window.location.pathname,
        userid,
        isLoggedIn,
        lang,
        reg,
        env,
      );
    }
  }, [LayoutModel]);

  return (
    <div className={styles.wrapper} id={styles.test}>
      <div className={styles.section}>
        {Model.IsVisible ? (
          <Tabs labels={[PageData?.PaymentHistoryHeader]}>
            <TransactionHistory {...props} />
          </Tabs>
        ) : (
          PageData?.TransactionHistoryTableNoResults
        )}
      </div>
      
    </div>
  );
};

export default TransactionHistoryPageData;
